<ng-container *ngIf="machine">
  <header class="sidebar-header">
    <mat-icon class="sidebar-header-icon" [svgIcon]="getIconNameForMachineType()"></mat-icon>
    <h3 class="sidebar-header-title" vdw-ellipsis-label [text]="machine.name" matTooltipPosition="above"></h3>
    <button mat-icon-button class="mat-icon-action-button-sm-without-border" (click)="closeMachineDetail()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </header>

  <article>
    <app-disabled-form-input [label]="'MACHINE.DETAILS.MACHINE_TYPE' | bmsTranslate" [value]="'MACHINE.TYPES.' + machine.equipmentKind | bmsTranslate"> </app-disabled-form-input>

    <ng-container *ngIf="isMachineOfTypeCarpetLoom()">
      <app-disabled-form-input [label]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1}" [value]="activeQuality?.name"> </app-disabled-form-input>
      <app-disabled-form-input [label]="'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1}" [value]="activeCreel?.name"></app-disabled-form-input>
    </ng-container>

    <ng-container *ngIf="isMachineOfTypeWeaving()">
      <app-disabled-form-input [label]="'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1}" [value]="activeWeaveProduct?.name"> </app-disabled-form-input>
    </ng-container>

    <ng-container *ngIf="isMachineOfTypeTufting()">
      <app-disabled-form-input [label]="'TEXTILE_DATA.TUFT_PRODUCT.TUFT_PRODUCT' | bmsTranslate: {count: 1}" [value]="activeTuftProduct?.name"> </app-disabled-form-input>
    </ng-container>

    <ng-container *ngIf="isMachineOfTypePlastic()">
      <app-disabled-form-input [label]="'UTILITIES.TOOL.TOOL' | bmsTranslate: {count: 1}" [value]="activeTool?.name"> </app-disabled-form-input>
    </ng-container>
  </article>

  <footer *ngIf="canShowFooter()">
    <div class="button-skeleton-wrapper standard-btn">
      <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'MACHINE.ACTIONS.CREATE_PRODUCTION_ORDER' | bmsTranslate" (click)="createProductionOrderForMachine()">
        <mat-icon svgIcon="add-prod-order"></mat-icon>
      </button>
    </div>
  </footer>
</ng-container>
